module.exports = __webpack_public_path__ + "img/sv66on.c897677b.svg";